// extracted by mini-css-extract-plugin
export default {"tabs":"TutorSchedule_tabs__VBeyq","tip":"TutorSchedule_tip__80cU4"};